import { get, merge, unset } from 'lodash-es';
import urljoin from 'url-join';
import { axios, createClient, } from '@cbbt/lib-client-axios';
import { getMethodPath, getServiceErrorByCode, HTTP_METHOD, InternalServiceError, REST_PARAM_TYPE, ServiceDescriptor, TRANSPORT, typesafeKeys, } from '@cbbt/lib-interface';
export const getMethodPrefix = (serviceConfig, methodName) => {
    if (serviceConfig.useAPIM) {
        return `${serviceConfig.serviceName}-${methodName}${serviceConfig.testApis ? '-next' : ''}`;
    }
    else {
        return '';
    }
};
export const configBuilderFactory = (serviceDescriptor, methodName, serviceConfig) => {
    const requestClass = serviceDescriptor.coreMethodsMetadata[methodName].request;
    const restMethodMetadata = serviceDescriptor.restMethodsMetadata[methodName];
    const baseConfig = {
        ...serviceConfig,
        method: restMethodMetadata.method,
        url: urljoin(getMethodPrefix(serviceConfig, restMethodMetadata.group || methodName), getMethodPath(serviceDescriptor, methodName)),
    };
    if (requestClass) {
        return (...args) => {
            const config = merge({ headers: {} }, baseConfig, args[1] || {});
            const message = args[0] instanceof requestClass
                ? args[0]
                : requestClass.create(args[0]);
            const data = message.toJSON(TRANSPORT.REST);
            restMethodMetadata?.params?.forEach((param) => {
                const value = get(data, param.to);
                unset(data, param.to);
                switch (param.type) {
                    case REST_PARAM_TYPE.HEADER:
                        config.headers[param.from] = value;
                        break;
                    case REST_PARAM_TYPE.PATH:
                        config.url = config.url?.replace(`{${param.from}}`, value);
                        break;
                    case REST_PARAM_TYPE.QUERY:
                        config.params = config.params || {};
                        config.params[param.from] = value;
                        break;
                    case REST_PARAM_TYPE.COOKIE:
                        break;
                }
            });
            if (restMethodMetadata.method !== HTTP_METHOD.GET &&
                restMethodMetadata.body) {
                config.data = restMethodMetadata.body.to
                    ? get(data, restMethodMetadata.body.to)
                    : data;
            }
            return config;
        };
    }
    else {
        return (...args) => merge({}, baseConfig, args[0] || {});
    }
};
export const createRestClient = (service, serviceConfig) => {
    const serviceDescriptor = ServiceDescriptor.load(service);
    const client = createClient({
        name: serviceDescriptor.serviceMetadata.core.serviceName,
        ...serviceConfig,
    });
    return typesafeKeys(serviceDescriptor.restMethodsMetadata).reduce((map, methodName) => {
        const responseClass = serviceDescriptor.coreMethodsMetadata[methodName].response;
        const configBuilder = configBuilderFactory(serviceDescriptor, methodName, serviceConfig);
        const apiCall = async (...args) => {
            const config = configBuilder(...args);
            try {
                config.headers = config.headers || {};
                const res = await client(config);
                if (responseClass) {
                    return responseClass.create(res.data);
                }
                else {
                    return undefined;
                }
            }
            catch (error) {
                let serviceError;
                if (axios.isAxiosError(error) && error?.response) {
                    const ErrorType = getServiceErrorByCode(error.response?.data?.errors[0]
                        ?.code) || InternalServiceError;
                    serviceError = new ErrorType({
                        ...(error.response?.data
                            ?.errors[0] || {}),
                    });
                }
                else {
                    serviceError = new InternalServiceError({ error });
                }
                throw serviceError;
            }
        };
        map[methodName] = apiCall;
        return map;
    }, { __CLIENT__: client });
};
export const singleBrandConfigSchema = {
    type: 'object',
    properties: {
        useAPIM: { type: 'boolean' },
        serviceName: {
            type: 'string',
        },
        testApis: { type: 'boolean', default: false },
        baseURL: { type: 'string', format: 'uri' },
    },
    required: ['useAPIM', 'baseURL', 'serviceName'],
};
//# sourceMappingURL=createRestClient.js.map